module.exports = "/images/close.svg";